// Shared button styles for MediaFileCard components

export const disabledButtonStyles = {
  bg: "transparent",
  border: "1px solid",
  borderColor: "gray.300",
  color: "gray.400",
  _hover: { bg: "transparent", cursor: "not-allowed" },
  _active: { bg: "transparent" },
  _disabled: {
    bg: "transparent",
    borderColor: "gray.300",
    color: "gray.400",
    opacity: 1,
    cursor: "not-allowed",
  },
};

export const enabledButtonStyles = {
  bg: "white",
  border: "1px solid",
  borderColor: "blue.600",
  color: "blue.600",
  _hover: { bg: "blue.50", color: "blue.500", borderColor: "blue.500" },
  _active: { bg: "blue.100", color: "blue.400", borderColor: "blue.400" },
};
